import Service from '@ember/service';

export interface UploadProviderOptions {
  isSlr: boolean;
  hasSyf: boolean;
  hasPslf: boolean;
  isWellnessOnly: boolean;
  preferredProviderOnly?: 'nslds' | 'statement';
}

export interface UploadProviderParams {
  source: 'slr' | 'pslf' | 'syf' | 'dashboard';
  providers: 'nslds,statement' | 'statement,nslds' | 'nslds' | 'statement';
}

export default class UploadProviderLogicService extends Service {
  getUploadParams(options: UploadProviderOptions) {
    const isPslfOnly = options.hasPslf && !options.isSlr && !options.hasSyf;
    const shouldPreferNslds = options.isWellnessOnly || isPslfOnly;
    const providers = options.preferredProviderOnly
      ? options.preferredProviderOnly
      : shouldPreferNslds
        ? 'nslds,statement'
        : 'statement,nslds';
    const source = options.isSlr
      ? 'slr'
      : options.hasPslf
        ? 'pslf'
        : options.hasSyf
          ? 'syf'
          : 'dashboard';

    return { providers, source };
  }
}
